module.exports = __webpack_public_path__ + "img/share-07.b6600f91.svg";